import styled from 'styled-components'
import LoginScreen from '../../assets/images/Login/LoginImage.svg'

export const Container = styled.div`
  background: linear-gradient(180deg, #0384b9 0%, #150d49 100%);
  height: 100vh;
  width: 100vw;
  display: flex;
  gap: 1rem;
`

export const LoginImage = styled.div`
  height: 100%;
  width: 60%;
  display: flex;
  background-image: url(${LoginScreen});
  background-size: cover;
  background-repeat: no-repeat;
`

export const Content = styled.div`
  height: 100%;
  width: 40%;
  background-color: ${(props) => props.theme.color.neutral.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`

export const MainContent = styled.div`
  height: calc(100% - 20rem);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  top: 0;
  justify-content: center;
`

export const LogoImage = styled.img`
  height: 4.5rem;
  width: auto;
  font-size: ${(props) => props.theme.font.textcaption};
`

export const ButtonContainer = styled.div`
  width: 55%;
`

export const Lane = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  & > div {
    background-color: ${(props) => props.theme.color.purple.purple500};
    opacity: 0.5;
    height: 1.5px;
    width: 55%;
  }

  & > span {
    color: ${(props) => props.theme.color.purple.purple800};
    opacity: 1;
    font-size: ${(props) => props.theme.font.textsm};
    position: absolute;
    display: flex;
    width: fit-content;
    left: 0;
    right: 0;
    top: -8px;
    bottom: 0;
    margin: auto;
    padding: 0 1rem;
    background-color: ${(props) => props.theme.color.neutral.white};
  }
`

export const ContactSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`

export const Text = styled.p`
  font-size: ${(props) => props.theme.font.textoverline};
  color: ${(props) => props.theme.color.neutral.gray};
`

export const Link = styled.a`
  font-size: ${(props) => props.theme.font.textsm};
  color: ${(props) => props.theme.color.purple.purple900};
  font-weight: 700;
  cursor: pointer;
  outline: none;
  text-decoration: none;
`

export const LoginFooter = styled.div`
  height: 2rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.color.blue.blue100};
  position: absolute;
  bottom: 0;
`
